import React, { FC, useState } from 'react';
import { Dropdown, Menu, Radio } from 'antd';
import styles from './styles.module.css';
import ToolbarButton from '../ToolbarButton';

type Props = {
  visibility?: boolean;
  getContainer: () => HTMLDivElement;
  onChange: (visibility: boolean) => void;
  disabled: boolean;
};

const BulkVisibility: FC<Props> = ({
  getContainer,
  visibility,
  onChange,
  disabled
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  return (
    <Dropdown
      disabled={disabled}
      className={styles.visibilityDropdown}
      trigger={['click']}
      getPopupContainer={getContainer}
      onOpenChange={setVisible}
      open={visible}
      placement="top"
      arrow={{ pointAtCenter: true }}
      overlayClassName={styles.bulkVisibilityOverlay}
      overlay={
        <Menu className={styles.visibilityMenu}>
          <Radio.Group name="bulkVisibility">
            {['Members', 'Members & Clients'].map(label => {
              return (
                <Radio
                  key={label}
                  className={styles.visibilityMenuItem}
                  value={label === 'Members & Clients'}
                  onChange={() => {
                    onChange(label === 'Members & Clients');
                    setTimeout(() => setVisible(false), 400);
                  }}
                >
                  {label}
                </Radio>
              );
            })}
          </Radio.Group>
        </Menu>
      }
    >
      <ToolbarButton
        active={typeof visibility === 'boolean'}
        open={visible}
        label={'Visible to'.toLowerCase()}
        onClick={() => setVisible(!visible)}
        disabled={disabled}
      />
    </Dropdown>
  );
};

export default BulkVisibility;
